import { graphql } from '@/generated/gql';

export const COMMENTS_QUERY = graphql(/* GraphQL */ `
  query CommentsQuery(
    $entityId: UUID!
    $entityVariant: TsrctCommentParentVariant!
    $sort: TsrctCommentSortOrder = DESC
    $limit: Int = 100
  ) {
    tesseract {
      comments(parent: { id: $entityId, variant: $entityVariant }, sort: $sort, limit: $limit) {
        id
        authorId
        message
        createdAt
        updatedAt
        parent {
          id
          variant
        }
      }
    }
  }
`);

export const ADD_COMMENT_MUTATION = graphql(/* GraphQL */ `
  mutation AddComment($id: UUID!, $message: String!, $parentId: UUID!, $parentVariant: TsrctCommentParentVariant!) {
    tesseract {
      comment {
        create(data: { id: $id, message: $message, parent: { id: $parentId, variant: $parentVariant } }) {
          id
          authorId
          message
          createdAt
          updatedAt
          parent {
            id
            variant
          }
        }
      }
    }
  }
`);

export const EDIT_COMMENT_MUTATION = graphql(/* GraphQL */ `
  mutation EditComment($id: UUID!, $message: String!, $parentId: UUID!, $parentVariant: TsrctCommentParentVariant!) {
    tesseract {
      comment {
        edit(data: { id: $id, message: $message, parent: { id: $parentId, variant: $parentVariant } }) {
          id
          authorId
          message
          createdAt
          updatedAt
          parent {
            id
            variant
          }
        }
      }
    }
  }
`);

export const DELETE_COMMENT_MUTATION = graphql(/* GraphQL */ `
  mutation DeleteComment($id: UUID!) {
    tesseract {
      comment {
        delete(id: $id) {
          id
          parent {
            id
            variant
          }
          createdAt
          updatedAt
          deletedAt
          message
        }
      }
    }
  }
`);
